import { request } from './http-client'

const oauthService = {
  signIn: (data: any) => request.post('/v1/oauth2/sign-in', data),
  signUp: (data: any) => request.post('/v1/oauth2/sign-up', data),
}

export default oauthService
